// extracted by mini-css-extract-plugin
export default {"container":"style_container__vrhNW","items":"style_items__PVDBz","itemsCategories":"style_itemsCategories__RBzYT","types":"style_types__Lllo2"};